<template>
  <vs-popup id="popupCompany" :title="popupTitle" :active.sync="showPopup" style="z-index: 53001">

    <vs-row>
      <vs-col style="max-height: 500px; overflow-y: auto">
        <vs-table stripe ref="table" :sst="true" :data="companyList" noDataText="데이터가 없습니다" @selected="handleItemClickDetail" @dblSelection="handleClickSelect">
          <template slot="thead">
            <vs-th class="">No.</vs-th>
            <vs-th class="">업체명</vs-th>
            <vs-th class="">사업자등록번호</vs-th>
          </template>

          <template>
            <vs-tr :class="selectCompany.id === company.id ? 'active' : ''" :data="company" :key="index" v-for="(company, index) in companyList">
              <vs-td>{{ company.id }}</vs-td>
              <vs-td>{{ company.com_name }}</vs-td>
              <vs-td>{{ company.com_number }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>

      </vs-col>

      <vs-col class="mt-4 flex" vs-align="center" vs-justify="flex-end">
        <vs-button class="mr-4" color="#EDEDED" text-color="black" type="filled" @click="handleClickClose">닫기 </vs-button>
        <vs-button class="" color="secondary" @click="handleClickSelect">선택</vs-button>
      </vs-col>
    </vs-row>
  </vs-popup>
</template>

<script>
import KPagination from "@/components/kPagination/kPagination";
export default {
  name: "popupCompany",
  props: {
    value: Boolean,
    title: {
      type: String,
      default: "",
    },
    companyList: {
      type: Array,
      default: () => [],
    },
  },
  components: { KPagination },

  watch: {
    value(data) {
      this.showPopup = data;
    },
    showPopup(data) {
      console.log('showPopup', data);
      this.$emit("input", data);
    },
  },
  computed: {
    popupTitle() {
      return this.title === "" ? "업체선택" : this.title;
    },
  },
  data() {
    return {
      showPopup: false,

      selectCompany: {},

    };
  },

  mounted() {
    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {
      if (this.showPopup) {
        this.showPopup = false;
        next(false);
        return;
      }
      next(true);
    });
    this.$once("hook:destroyed", () => {
      backButtonRouteGuard();
    });
  },

  created() {
    this.showPopup = this.value;
  },

  methods: {
    handleClickClose() {
      this.$emit("input", false);
      this.$emit("handleClickClose");
    },

    handleItemClickDetail(data) {
      if (this.selectCompany === data) {
        this.handleClickSelect();
      } else {
        this.selectCompany = data;
      }
    },

    handleClickSelect(data) {
      // 리스트에서 더블클릭됐을 때는 아이템 데이터가 전달된다
      if (data && data.id) {
        this.handleItemClickDetail(data);
      }

      this.$emit("input", false);
      this.$emit("handleSelect", this.selectCompany);
    },
  },
};
</script>

<style lang="scss" scoped>
#popupCompany::v-deep .vs-popup {
  width: 90% !important;
  @media print, screen and (min-width: theme("screens.xl")) {
    width: 1200px !important;
  }

  .vs-con-table.stripe .tr-values.active {
    background: rgb(102, 112, 203) !important;
    color: #fff;
    font-width: bold;
  }
}
</style>
